import React from 'react';
import { Send, X } from 'lucide-react';

const BidModal = ({ jobId, onClose, onSubmit }) => {
  const [bidAmount, setBidAmount] = React.useState('');
  const [message,   setMessage]   = React.useState('');
  const [loading,   setLoading]   = React.useState(false);

  const handleSubmit = () => {
    if (!bidAmount) return;
    setLoading(true);
    onSubmit(jobId, bidAmount, message, () => {
      setLoading(false);
      onClose();
    });
  };

  return (
    <div className="bj-modal-overlay">
      <div className="bj-dispute-modal" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="bj-dispute-modal__header" style={{ background: 'linear-gradient(135deg,#e8f4fd,#fff)' }}>
          <div className="bj-dispute-modal__icon" style={{ background: 'rgba(4,145,225,0.12)', color: '#0491e1' }}>
            <Send size={18}/>
          </div>
          <div>
            <h4 className="bj-dispute-modal__title">Place a Bid</h4>
            <p className="bj-dispute-modal__sub">Submit your offer to the customer</p>
          </div>
          <button className="bj-dispute-modal__close" onClick={onClose}><X size={16}/></button>
        </div>

        {/* Body */}
        <div className="bj-dispute-modal__body">

          {/* Bid Amount */}
          <div className="bj-dispute-modal__field">
            <label>Bid Amount ($) *</label>
            <input
              type="number"
              placeholder="Enter your bid amount"
              value={bidAmount}
              min="1"
              onChange={e => setBidAmount(e.target.value)}
              style={{
                width: '100%', padding: '11px 14px',
                background: '#f8fafc', border: '1.5px solid #d0e7f5',
                borderRadius: '11px', color: '#484745', outline: 'none',
              }}
            />
          </div>

          {/* Message */}
          <div className="bj-dispute-modal__field">
            <label>Message (optional)</label>
            <textarea
              placeholder="Write a message to the customer..."
              value={message}
              onChange={e => setMessage(e.target.value)}
              rows={3}
            />
          </div>

        </div>

        {/* Footer */}
        <div className="bj-dispute-modal__footer">
          <button className="bj-dispute-modal__cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="bj-dispute-modal__submit-btn"
            onClick={handleSubmit}
            disabled={!bidAmount || loading}
            style={{ background: '#0491e1', boxShadow: '0 4px 14px rgba(4,145,225,0.30)' }}
          >
            {loading
              ? <span className="bj-spinner"/>
              : <><Send size={14}/> Submit Bid</>
            }
          </button>
        </div>

      </div>
    </div>
  );
};

export default BidModal;